import { Type } from '@sinclair/typebox';
import { UuidSchema } from './common.js';
import { TfChatMessageSchema, TfChatSessionSchema } from './tables.js';
// GET /sessions
export const ListSessionsQuerySchema = Type.Object({
    trackId: Type.Optional(UuidSchema),
    cursor: Type.Optional(Type.String()),
    limit: Type.Optional(Type.Integer({ minimum: 1, maximum: 100 })),
});
/**
 * COP-134 D1 / ATRU-04 — a `GET /sessions` row.
 *
 * `scheduledRunId` is DERIVED from the existing `tf_chat_session.metadata`
 * marker COP-131 already writes (see `ScheduledSessionMetadataSchema` below);
 * there is no column, no new write path and no backfill. It is a typed handle
 * back to the run that produced the session, so a client does not have to read
 * the untrusted metadata bag by hand.
 *
 * COP-131 rule: PRESENT or ABSENT, never `null` — absent means no scheduled
 * run created this session, which is what every interactive session holds.
 */
export const SessionSummarySchema = Type.Composite([
    TfChatSessionSchema,
    Type.Object({
        scheduledRunId: Type.Optional(UuidSchema),
    }),
]);
export const ListSessionsResponseSchema = Type.Object({
    sessions: Type.Array(SessionSummarySchema),
    nextCursor: Type.Union([Type.String(), Type.Null()]),
});
/**
 * COP-131 — `tf_chat_session.metadata` origin marker.
 *
 * A scheduled run invokes `handleTurn` with no `sessionId`, so it creates a
 * session that is indistinguishable from a user's first turn in the picker.
 * The hub stamps this object on the row at creation; the marker is the ONLY
 * consumer contract on that column, so widening it stays additive.
 *
 * `origin` absent (or `metadata` null) means a user typed the session — the
 * pre-COP-131 shape, and the shape every row created before this landed has.
 */
export const SESSION_ORIGIN_SCHEDULE = 'schedule';
export const ScheduledSessionMetadataSchema = Type.Object({
    origin: Type.Literal(SESSION_ORIGIN_SCHEDULE),
    scheduleId: UuidSchema,
    scheduledRunId: UuidSchema,
});
/**
 * True when a session row was created by a scheduled run. Reads only `origin`
 * so a row written by an older or newer hub still classifies correctly, and
 * never throws on an arbitrary jsonb value.
 */
export function isScheduledSessionMetadata(metadata) {
    return metadata?.origin === SESSION_ORIGIN_SCHEDULE;
}
// GET /sessions/:id/messages + DELETE /sessions/:id
export const SessionIdParamsSchema = Type.Object({
    id: UuidSchema,
});
export const SessionMessagesResponseSchema = Type.Object({
    session: TfChatSessionSchema,
    messages: Type.Array(TfChatMessageSchema),
});
//# sourceMappingURL=sessions.js.map